import type { StdObject } from '~/types/internal'
import type { Section } from '~/types/section'
import { locales } from '@@/shared-components/locales/index'

export const sectionQuery = ({
  sectionName,
  enabled,
  query,
  thumbs,
  placeholderData,
  hasPreview,
  origin,
  dataLang,
  throwOnError = true,
}: {
  enabled?: Ref<boolean>
  sectionName: Ref<string>
  query?: Ref<object>
  thumbs?: StdObject
  placeholderData?: { data: Section }
  hasPreview?: { expires: string; signature: string }
  origin?: string
  throwOnError?: boolean
  dataLang: Ref<ValueOf<typeof locales>>
}) =>
  queryOptions({
    enabled,
    queryKey: ['sections', sectionName, dataLang],
    queryFn: async (): Promise<{
      data: Section
    }> =>
      await useCustomFetch<{ data: Section }>({
        url: `/public/sections/${hasPreview ? 'p/' : ''}${sectionName.value}`,
        query: { ...query?.value, ...(hasPreview ?? {}) },
        thumbs,
        origin,
        clientOnly: true,
        options: { headers: { 'X-Lang': dataLang.value } },
      }),
    placeholderData,
    throwOnError,
  })
